import Vue from 'vue'
import Router from 'vue-router'
import auth from '../auth/auth'

Vue.use(Router)

export const Routes = {
    NEW_RULE: 'New Rule',
    EDIT_RULE: 'Edit Rule',
    RULE_LIST: 'Rule List',
    AUDIT_LOG_RULE: 'Rule Audit log',
    AUDIT_LOG: 'Audit log',
    DETECTION_REPORT: 'Detection Report',
    FORBIDDEN: 'Forbidden Access',
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            name: Routes.RULE_LIST,
            path: '/',
            component: () => import('@/views/RuleList'),
            meta: { permissionLevel: 'view' },
        },
        {
            name: Routes.NEW_RULE,
            path: '/add-rule',
            component: () => import('@/views/NewRule'),
            meta: { permissionLevel: 'add' },
        },
        {
            name: Routes.EDIT_RULE,
            path: '/rule/:ruleId/edit',
            props: true,
            component: () => import('@/views/EditRule'),
            meta: { permissionLevel: 'edit' },
        },
        {
            name: Routes.AUDIT_LOG_RULE,
            path: '/audit-log-rule/:ruleId',
            props: true,
            component: () => import('@/views/RuleAuditLog'),
            meta: { permissionLevel: 'view' },
        },
        {
            name: Routes.AUDIT_LOG,
            path: '/audit-log',
            component: () => import('@/views/GeneralAuditLog'),
            meta: { permissionLevel: 'view' },
        },
        {
            name: Routes.DETECTION_REPORT,
            path: '/detection-report',
            component: () => import('@/views/DetectionReport'),
            meta: { permissionLevel: 'view' },
        },
        {
            name: Routes.FORBIDDEN,
            path: '/forbidden',
            component: () => import('@/views/Forbidden'),
        },
    ],
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.permissionLevel === 'view')) {
        if (auth.canView()) {
            next()
        } else {
            next({ name: Routes.FORBIDDEN })
        }
    } else if (to.matched.some(record => record.meta.permissionLevel === 'add')) {
        if (auth.canAdd()) {
            next()
        } else {
            next({ name: Routes.FORBIDDEN })
        }
    } else if (to.matched.some(record => record.meta.permissionLevel === 'edit')) {
        if (auth.canEdit()) {
            next()
        } else {
            next({ name: Routes.FORBIDDEN })
        }
    } else if (to.matched.some(record => record.meta.permissionLevel === 'delete')) {
        if (auth.canDelete()) {
            next()
        } else {
            next({ name: Routes.FORBIDDEN })
        }
    }
    next()
})

export default router
